var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.theme.components.BaseElementLayout, {
    tag: "component",
    attrs: {
      "el$": _vm.el$
    }
  }, [_c('template', {
    slot: "field"
  }, [_vm._t("prefix"), _vm._t("label", null, {
    "slot": "label",
    "el$": _vm.el$
  }), _c('div', {
    staticClass: "purchase_orders"
  }, _vm._l(this.purchase_orders, function (item, index) {
    return _c('v-flex', {
      key: item.POPH_Reference,
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', {
      attrs: {
        "raised": "",
        "tile": ""
      }
    }, [_c('v-card-title', {
      key: "title".concat(index),
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "color": "gray"
      }
    }, [_vm._v("\n            " + _vm._s(item.POPH_Reference) + "\n            "), _c('v-spacer'), _vm._v("\n            £" + _vm._s(item.POPH_Total_Value_Ex_VAT_Home) + "\n          ")], 1), _vm.purchase_orders_model[item.POPH_Reference] ? _c('v-card-text', {
      staticClass: "purchase_order"
    }, [_vm._v("\n            " + _vm._s(item.SUPP_Name) + "\n            "), _c('v-flex', {
      attrs: {
        "xs-12": ""
      }
    }, [_c('label', [_c('v-checkbox', {
      attrs: {
        "label": "Used"
      },
      on: {
        "click": _vm.handlePurchaseOrderModel
      },
      model: {
        value: _vm.purchase_orders_model[item.POPH_Reference].used,
        callback: function callback($$v) {
          _vm.$set(_vm.purchase_orders_model[item.POPH_Reference], "used", $$v);
        },
        expression: "purchase_orders_model[item.POPH_Reference].used"
      }
    })], 1)]), _vm.purchase_orders_model[item.POPH_Reference].used && _vm.po_type == 'MAT' ? _c('v-flex', {
      attrs: {
        "xs-12": ""
      }
    }, [_c('v-label', [_vm._v("GRN")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.purchase_orders_model[item.POPH_Reference].grn,
        expression: "purchase_orders_model[item.POPH_Reference].grn"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "name": item.POPH_Reference,
        "id": item.POPH_Reference,
        "placeholder": "Enter GRN Ref"
      },
      domProps: {
        "value": _vm.purchase_orders_model[item.POPH_Reference].grn
      },
      on: {
        "keyup": _vm.handlePurchaseOrderModel,
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.purchase_orders_model[item.POPH_Reference], "grn", $event.target.value);
        }
      }
    })], 1) : _vm._e(), _vm.purchase_orders_model[item.POPH_Reference].used && _vm.po_type == 'HIR' ? _c('v-flex', {
      attrs: {
        "xs-12": ""
      }
    }, [_c('v-label', [_vm._v("Off Hire Ref")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.purchase_orders_model[item.POPH_Reference].off_hire_number,
        expression: "\n                  purchase_orders_model[item.POPH_Reference].off_hire_number\n                "
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "name": item.POPH_Reference,
        "id": item.POPH_Reference,
        "placeholder": "Enter Off Hire Ref",
        "rules": ""
      },
      domProps: {
        "value": _vm.purchase_orders_model[item.POPH_Reference].off_hire_number
      },
      on: {
        "keyup": _vm.handlePurchaseOrderModel,
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.purchase_orders_model[item.POPH_Reference], "off_hire_number", $event.target.value);
        }
      }
    })], 1) : _vm._e()], 1) : _vm._e()], 1)], 1);
  }), 1), _vm._t("suffix")], 2), _vm._t("info", function () {
    return [_c('v-btn', {
      attrs: {
        "color": "success",
        "flat": "",
        "icon": ""
      },
      on: {
        "click": function click($event) {
          return _vm.refreshPurchaseOrders();
        }
      }
    }, [_c('v-icon', [_vm._v("refresh")])], 1)];
  }, {
    "slot": "info",
    "el$": _vm.el$
  }), _vm._t("before", null, {
    "slot": "before",
    "el$": _vm.el$
  }), _vm._t("between", null, {
    "slot": "between",
    "el$": _vm.el$
  }), _vm._t("error", null, {
    "slot": "error",
    "el$": _vm.el$
  }), _vm._t("after", null, {
    "slot": "after",
    "el$": _vm.el$
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }